import { GAME_CONFIG } from '../data/gameConfig';
import { addTollocanInfrastructure } from './tollocanInfrastructure';
import { addTollocanMonument } from './tollocanMonuments';
import runnerRunTextureImage from '../../../assets/pixellab/diablito-float-south.webp';
import runnerRunSheet from '../../../assets/pixellab/diablito-float-south.json';
import runnerSmileTextureImage from '../../../assets/pixellab/diablito-smile-south.webp';
import runnerVictoriaTextureImage from '../../../assets/pixellab/diablito-spin-victoria.webp';
import runnerSaltoTextureImage from '../../../assets/pixellab/diablito-spin-salto.webp';
import streetTileImage from '../../../assets/street/street-tile.webp';
import streetPotholeImage from '../../../assets/street/decal-pothole.webp';
import streetRubbleImage from '../../../assets/street/decal-rubble.webp';
import streetDrainImage from '../../../assets/street/decal-drain.webp';
import streetPuddleSheetImage from '../../../assets/street/puddle-run.webp';
import skyTextureImage from '../../../assets/pixellab/haunted-sky.webp';
import cloudTextureImage from '../../../assets/pixellab/storm-clouds.webp';
import mountainTextureImage from '../../../assets/pixellab/nevado-toluca.webp';
import portalesFacadeImage from '../../../assets/pixellab/toluca-portales.webp';
import neoclassicalFacadeImage from '../../../assets/pixellab/toluca-neoclassical.webp';
import artNouveauFacadeImage from '../../../assets/pixellab/toluca-art-nouveau.webp';
import dogRunTextureImage from '../../../assets/pixellab/dog-run.webp';
import catRunTextureImage from '../../../assets/pixellab/cat-run.webp';
import streetLampImage from '../../../assets/pixellab/toluca-street-lamp.webp';
import trashBinImage from '../../../assets/pixellab/municipal-trash-bin.webp';
import vendorPedalingTextureImage from '../../../assets/pixellab/street-vendor-pedaling.webp';
import urbanTreeImage from '../../../assets/pixellab/toluca-urban-tree.webp';
import utilityPoleImage from '../../../assets/pixellab/mexican-utility-pole.webp';
import northernPalmImage from '../../../assets/pixellab/norte-palm.webp';
import northernHouseImage from '../../../assets/pixellab/norte-house.webp';
import northernChurchImage from '../../../assets/pixellab/norte-church.webp';
import northernBridgeImage from '../../../assets/pixellab/norte-bridge.webp';
import northernSiloImage from '../../../assets/pixellab/norte-silo.webp';
import northernStreetDogImage from '../../../assets/pixellab/norte-street-dog-run.webp';
import northernStreetDogSheet from '../../../assets/pixellab/norte-street-dog-run.json';
import northernCyclistFrontImage from '../../../assets/pixellab/norte-cyclist-front.webp';
import northernCyclistFrontSheet from '../../../assets/pixellab/norte-cyclist-front.json';
import northernCyclistBackImage from '../../../assets/pixellab/norte-cyclist-back.webp';
import northernCyclistBackSheet from '../../../assets/pixellab/norte-cyclist-back.json';
import menuBackgroundImage from '../../../assets/fondocementerio.webp';
import hudLogoImage from '../../../assets/logo.webp';
import streakDevilImage from '../../../assets/pixellab/diablito-smile-portrait.webp';
import nohoLogoImage from '../../../assets/LOGONOHO.gif';
import cuWallImage from '../../../assets/pixellab/cu-wall.webp';
import cuNoticesImage from '../../../assets/pixellab/cu-wall-notices.webp';
import cuCracksImage from '../../../assets/pixellab/cu-wall-cracks.webp';
import cuFloorImage from '../../../assets/pixellab/cu-floor.webp';
import cuLockerImage from '../../../assets/pixellab/cu-locker.webp';
import cuDoorImage from '../../../assets/pixellab/cu-door.webp';
import parkDirtTextureImage from '../../../assets/pixellab/park-dirt.webp';
import parkGrassTextureImage from '../../../assets/pixellab/park-grass.webp';
import parkWaterTextureImage from '../../../assets/pixellab/park-water.webp';
import parkTreeOakImage from '../../../assets/pixellab/park-tree-oak.webp';
import parkTreePineImage from '../../../assets/pixellab/park-tree-pine.webp';
import parkTreeDeadImage from '../../../assets/pixellab/park-tree-dead.webp';
import parkUnderstoryImage from '../../../assets/pixellab/park-understory.webp';
import parkRocksImage from '../../../assets/pixellab/park-rocks.webp';
import parkTimberTextureImage from '../../../assets/pixellab/park-timber.webp';
import parkRabbitTextureImage from '../../../assets/pixellab/park-rabbit-run.webp';
import parkRabbitSheet from '../../../assets/pixellab/park-rabbit-run.json';
import parkSquirrelTextureImage from '../../../assets/pixellab/park-squirrel-run.webp';
import parkSquirrelSheet from '../../../assets/pixellab/park-squirrel-run.json';
import parkDuckTextureImage from '../../../assets/pixellab/park-duck-swim.webp';
import parkDuckSheet from '../../../assets/pixellab/park-duck-swim.json';
import parkHeronTextureImage from '../../../assets/pixellab/park-heron-flap.webp';
import parkHeronSheet from '../../../assets/pixellab/park-heron-flap.json';
import parkAxolotlTextureImage from '../../../assets/pixellab/park-axolotl-swim.webp';
import parkAxolotlSheet from '../../../assets/pixellab/park-axolotl-swim.json';
import tollocanRoadImage from '../../../assets/pixellab/tollocan-road.webp';
import tollocanTreeImage from '../../../assets/pixellab/tollocan-tree.webp';
import tollocanTreeAImage from '../../../assets/pixellab/tollocan-tree-a.webp';
import tollocanTreeBImage from '../../../assets/pixellab/tollocan-tree-b.webp';
import tollocanTreeCImage from '../../../assets/pixellab/tollocan-tree-c.webp';
import tollocanSpeed60Image from '../../../assets/pixellab/tollocan-speed-60.webp';
import tollocanCurveImage from '../../../assets/pixellab/tollocan-curve.webp';
import tollocanRailCrossImage from '../../../assets/pixellab/tollocan-rail-cross.webp';
import tollocanTowersImage from '../../../assets/pixellab/tollocan-towers.webp';
import tollocanVolcanicStoneImage from '../../../assets/pixellab/tollocan-volcanic-stone.png';
import tollocanConcreteImage from '../../../assets/pixellab/tollocan-concrete.png';
import tollocanGrassImage from '../../../assets/pixellab/tollocan-grass.png';


const GAME_IMAGE_ASSETS = [
  { url: runnerRunTextureImage, priority: 'high' },
  runnerSmileTextureImage,
  runnerVictoriaTextureImage,
  runnerSaltoTextureImage,
  { url: skyTextureImage, priority: 'high' },
  streetTileImage,
  streetPotholeImage,
  streetRubbleImage,
  streetDrainImage,
  streetPuddleSheetImage,
  cloudTextureImage,
  mountainTextureImage,
  portalesFacadeImage,
  neoclassicalFacadeImage,
  artNouveauFacadeImage,
  dogRunTextureImage,
  catRunTextureImage,
  streetLampImage,
  trashBinImage,
  vendorPedalingTextureImage,
  urbanTreeImage,
  utilityPoleImage,
  menuBackgroundImage,
  hudLogoImage,
  streakDevilImage,
  nohoLogoImage,
];

const NORTHERN_IMAGE_ASSETS = [
  northernPalmImage,
  northernHouseImage,
  northernChurchImage,
  northernBridgeImage,
  northernSiloImage,
  northernStreetDogImage,
  northernCyclistFrontImage,
  northernCyclistBackImage,
];

const NORTHERN_UNUSED_ASSETS = new Set([
  streetTileImage, streetPotholeImage, streetRubbleImage, streetDrainImage, streetPuddleSheetImage,
  portalesFacadeImage, neoclassicalFacadeImage, artNouveauFacadeImage,
  dogRunTextureImage, catRunTextureImage, streetLampImage, urbanTreeImage, utilityPoleImage,
]);

const CAMPUS_IMAGE_ASSETS = [cuWallImage, cuNoticesImage, cuCracksImage, cuFloorImage, cuLockerImage, cuDoorImage];
const CAMPUS_UNUSED_ASSETS = new Set([
  ...NORTHERN_UNUSED_ASSETS, skyTextureImage, cloudTextureImage, mountainTextureImage,
  trashBinImage, vendorPedalingTextureImage,
]);

const PARK_IMAGE_ASSETS = [
  parkDirtTextureImage,
  parkGrassTextureImage,
  parkWaterTextureImage,
  parkTreeOakImage,
  parkTreePineImage,
  parkTreeDeadImage,
  parkUnderstoryImage,
  parkRocksImage,
  parkTimberTextureImage,
  parkRabbitTextureImage,
  parkSquirrelTextureImage,
  parkDuckTextureImage,
  parkHeronTextureImage,
  parkAxolotlTextureImage,
];

const PARK_UNUSED_ASSETS = new Set([
  streetTileImage, streetPotholeImage, streetRubbleImage, streetDrainImage, streetPuddleSheetImage,
  skyTextureImage, cloudTextureImage, mountainTextureImage,
  portalesFacadeImage, neoclassicalFacadeImage, artNouveauFacadeImage,
  dogRunTextureImage, catRunTextureImage, streetLampImage, trashBinImage, vendorPedalingTextureImage,
  urbanTreeImage, utilityPoleImage,
  northernPalmImage, northernHouseImage, northernChurchImage, northernBridgeImage, northernSiloImage,
  northernStreetDogImage, northernCyclistFrontImage, northernCyclistBackImage,
]);

const TOLLOCAN_IMAGE_ASSETS = [
  tollocanRoadImage,
  tollocanTreeImage,
  tollocanTreeAImage,
  tollocanTreeBImage,
  tollocanTreeCImage,
  tollocanSpeed60Image,
  tollocanCurveImage,
  tollocanRailCrossImage,
  tollocanTowersImage,
  tollocanVolcanicStoneImage,
  tollocanConcreteImage,
  tollocanGrassImage,
];

const TOLLOCAN_UNUSED_ASSETS = new Set([
  streetTileImage, streetPotholeImage, streetRubbleImage, streetDrainImage, streetPuddleSheetImage,
  portalesFacadeImage, neoclassicalFacadeImage, artNouveauFacadeImage,
  dogRunTextureImage, catRunTextureImage, streetLampImage, trashBinImage, vendorPedalingTextureImage,
  urbanTreeImage, utilityPoleImage,
  northernPalmImage, northernHouseImage, northernChurchImage, northernBridgeImage, northernSiloImage,
  northernStreetDogImage, northernCyclistFrontImage, northernCyclistBackImage,
  mountainTextureImage,
  skyTextureImage, cloudTextureImage,
]);

const getGameImageAssets = (locationId) => {
  if (locationId === 'ceu') {
    return [...GAME_IMAGE_ASSETS.filter((asset) => !CAMPUS_UNUSED_ASSETS.has(asset.url || asset)), ...CAMPUS_IMAGE_ASSETS];
  }
  if (locationId === 'norte') {
    return [...GAME_IMAGE_ASSETS.filter((asset) => !NORTHERN_UNUSED_ASSETS.has(asset.url || asset)), ...NORTHERN_IMAGE_ASSETS];
  }
  if (locationId === 'parque') {
    return [...GAME_IMAGE_ASSETS.filter((asset) => !PARK_UNUSED_ASSETS.has(asset.url || asset)), ...PARK_IMAGE_ASSETS];
  }
  if (locationId === 'tollocan') {
    return [...GAME_IMAGE_ASSETS.filter((asset) => !TOLLOCAN_UNUSED_ASSETS.has(asset.url || asset)), ...TOLLOCAN_IMAGE_ASSETS];
  }
  return GAME_IMAGE_ASSETS;
};

const createLoadedTexture = (THREE, loadedImages, imageUrl) => {
  const image = loadedImages.get(imageUrl);
  if (!image) throw new Error(`Falta un recurso visual del juego: ${imageUrl}`);
  const texture = new THREE.Texture(image);
  texture.needsUpdate = true;
  return texture;
};

const createSeededRandom = (seed) => {
  let value = seed >>> 0;
  return () => {
    value = (value * 1664525 + 1013904223) >>> 0;
    return value / 4294967296;
  };
};

const createRailTexture = (THREE, renderer) => {
  // Generated once on the loading screen. Rails run along the UV vertical axis.
  const canvas = document.createElement('canvas');
  canvas.width = 256;
  canvas.height = 512;
  const context = canvas.getContext('2d');
  const random = createSeededRandom(0x5241494c);
  context.fillStyle = '#211f22';
  context.fillRect(0, 0, 256, 512);
  for (let index = 0; index < 4200; index += 1) {
    const shade = Math.floor(37 + random() * 37);
    context.fillStyle = `rgb(${shade},${shade - 1},${shade - 2})`;
    context.fillRect(Math.floor(random() * 256), Math.floor(random() * 512), 2 + random() * 4, 2 + random() * 3);
  }
  for (let y = 0; y < 512; y += 32) {
    context.fillStyle = '#141315';
    context.fillRect(47, y + 4, 162, 15);
    context.fillStyle = '#554843';
    context.fillRect(49, y + 5, 158, 11);
    context.fillStyle = '#302b2a';
    context.fillRect(49, y + 14, 158, 3);
  }
  [67, 186].forEach((x) => {
    context.fillStyle = '#100f11';
    context.fillRect(x - 5, 0, 13, 512);
    context.fillStyle = '#676866';
    context.fillRect(x - 3, 0, 7, 512);
    context.fillStyle = '#a1a19a';
    context.fillRect(x - 2, 0, 2, 512);
  });
  const texture = new THREE.CanvasTexture(canvas);
  texture.wrapS = THREE.ClampToEdgeWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.repeat.set(1, GAME_CONFIG.ground.textureRepeatY);
  texture.magFilter = THREE.NearestFilter;
  texture.anisotropy = Math.min(4, renderer.capabilities.getMaxAnisotropy());
  texture.encoding = THREE.sRGBEncoding;
  return texture;
};

const createRoadTexture = (THREE, renderer, loadedImages, locationId) => {
  if (locationId === 'norte') return createRailTexture(THREE, renderer);
  const { ground } = GAME_CONFIG;
  const campus = locationId === 'ceu';
  const park = locationId === 'parque';
  const tollocan = locationId === 'tollocan';
  const texture = createLoadedTexture(THREE, loadedImages, campus
    ? cuFloorImage
    : park ? parkDirtTextureImage : tollocan ? tollocanRoadImage : streetTileImage);
  texture.wrapS = campus || park || tollocan ? THREE.RepeatWrapping : THREE.ClampToEdgeWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.repeat.set(
    campus || park ? ground.shoulderWidth / 8 : 1,
    campus || park ? ground.length / 8 : ground.textureRepeatY,
  );
  if (campus || park || tollocan) texture.magFilter = THREE.NearestFilter;
  texture.anisotropy = Math.min(8, renderer.capabilities.getMaxAnisotropy());
  texture.encoding = THREE.sRGBEncoding;
  return texture;
};

const createRoadSurface = (THREE, renderer, loadedImages, locationId) => {
  const roadTexture = createRoadTexture(THREE, renderer, loadedImages, locationId);
  const roadWidth = locationId === 'parque' ? 13
    : locationId === 'tollocan' ? GAME_CONFIG.ground.roadWidth : GAME_CONFIG.ground.shoulderWidth;
  const roadSurface = new THREE.Mesh(
    new THREE.PlaneGeometry(roadWidth, GAME_CONFIG.ground.length),
    new THREE.MeshStandardMaterial({
      color: {
        ceu: 0x697e7c,
        tollocan: 0xffffff,
        parque: 0x8f7961,
      }[locationId] || 0xffffff,
      map: roadTexture,
      roughness: 0.98,
      metalness: 0.04,
    }),
  );

  roadSurface.rotation.x = -Math.PI / 2;
  roadSurface.position.set(0, -0.5, (GAME_CONFIG.spawnZ + GAME_CONFIG.hitZ) * 0.5);

  return { roadSurface, roadTexture };
};

const STREET_DECAL_IMAGES = {
  pothole: streetPotholeImage,
  puddle: streetPuddleSheetImage,
  rubble: streetRubbleImage,
  drain: streetDrainImage,
};

const createRoadDecalTexture = (THREE, renderer, loadedImages, image, frameColumns, frameRows) => {
  const texture = createLoadedTexture(THREE, loadedImages, image);
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.anisotropy = Math.min(8, renderer.capabilities.getMaxAnisotropy());
  texture.encoding = THREE.sRGBEncoding;
  if (frameColumns) {
    texture.repeat.set(1 / frameColumns, 1 / (frameRows || 1));
    setSpriteSheetFrame(texture, 0, frameColumns, frameRows || 1);
  }
  return texture;
};

const createRoadDecals = (THREE, renderer, loadedImages, roadSurfaceY, locationId) => {
  const { decals } = GAME_CONFIG.ground;
  if (locationId === 'norte' || locationId === 'ceu' || locationId === 'parque' || locationId === 'tollocan') {
    return { group: new THREE.Group(), items: [], resources: [], spawnSpan: decals.recycleZ - GAME_CONFIG.spawnZ };
  }
  const random = createSeededRandom((Date.now() ^ 0x5f3759df) >>> 0);
  const group = new THREE.Group();
  const items = [];
  const resources = [];
  const halfLane = (GAME_CONFIG.ground.roadWidth / 2) - decals.laneMargin;
  const spawnSpan = decals.recycleZ - GAME_CONFIG.spawnZ;

  Object.entries(decals.types).forEach(([kind, settings]) => {
    const animated = Boolean(settings.frameColumns);
    const sharedTexture = animated
      ? null
      : createRoadDecalTexture(THREE, renderer, loadedImages, STREET_DECAL_IMAGES[kind]);

    if (sharedTexture) resources.push(sharedTexture);

    for (let index = 0; index < settings.count; index += 1) {
      const scale = settings.size * (1 - decals.scaleJitter * 0.5 + random() * decals.scaleJitter);
      const texture = animated
        ? createRoadDecalTexture(THREE, renderer, loadedImages, STREET_DECAL_IMAGES[kind], settings.frameColumns, settings.frameRows)
        : sharedTexture;
      if (animated) resources.push(texture);

      const geometry = new THREE.PlaneGeometry(scale, scale);
      const material = new THREE.MeshStandardMaterial({
        map: texture,
        transparent: true,
        alphaTest: 0.08,
        roughness: 0.96,
        metalness: 0.04,
      });
      const mesh = new THREE.Mesh(geometry, material);
      mesh.rotation.x = -Math.PI / 2;
      mesh.rotation.z = settings.spin ? Math.floor(random() * 4) * (Math.PI / 2) : 0;
      mesh.position.set(
        (random() * 2 - 1) * halfLane,
        roadSurfaceY + decals.yOffset,
        decals.recycleZ - random() * spawnSpan,
      );
      group.add(mesh);

      resources.push(geometry, material);
      items.push({
        kind,
        mesh,
        texture,
        geometry,
        material,
        frameColumns: settings.frameColumns || 0,
        frameRows: settings.frameRows || 1,
        frameSequence: animated ? Array.from({ length: settings.frameColumns * (settings.frameRows || 1) }, (_, i) => i) : [],
        currentFrameIndex: 0,
        frameElapsed: random() * (settings.frameDuration || 0),
        frameDuration: settings.frameDuration || 0,
      });
    }
  });

  return { group, items, resources, spawnSpan };
};

const createSceneryTexture = (THREE, renderer, loadedImages, image) => {
  const texture = createLoadedTexture(THREE, loadedImages, image);
  texture.wrapS = THREE.ClampToEdgeWrapping;
  texture.wrapT = THREE.ClampToEdgeWrapping;
  texture.magFilter = THREE.NearestFilter;
  texture.anisotropy = Math.min(8, renderer.capabilities.getMaxAnisotropy());
  texture.encoding = THREE.sRGBEncoding;
  return texture;
};

const configurePixelSpriteTexture = (THREE, renderer, texture, columns = 1, rows = 1) => {
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  texture.repeat.set(1 / columns, 1 / rows);
  texture.magFilter = THREE.NearestFilter;
  texture.minFilter = THREE.NearestFilter;
  texture.generateMipmaps = false;
  texture.anisotropy = Math.min(4, renderer.capabilities.getMaxAnisotropy());
  texture.encoding = THREE.sRGBEncoding;
  return texture;
};

const setSpriteSheetFrame = (texture, frameIndex, columns, rows) => {
  const column = frameIndex % columns;
  const row = Math.floor(frameIndex / columns);
  texture.offset.x = column / columns;
  texture.offset.y = 1 - ((row + 1) / rows);
};

const advanceSpriteAnimation = (sprite, delta) => {
  if (!sprite?.frameSequence?.length || !sprite.texture) return;

  // Catch up after a slow frame without dropping the rhythm or looping forever
  // after a tab becomes visible again.
  sprite.frameElapsed += Math.min(delta, sprite.frameDuration * sprite.frameSequence.length);
  let didAdvance = false;

  while (sprite.frameElapsed >= sprite.frameDuration) {
    sprite.frameElapsed -= sprite.frameDuration;
    sprite.currentFrameIndex = (sprite.currentFrameIndex + 1) % sprite.frameSequence.length;
    didAdvance = true;
  }

  if (didAdvance) {
    setSpriteSheetFrame(
      sprite.texture,
      sprite.frameSequence[sprite.currentFrameIndex],
      sprite.frameColumns,
      sprite.frameRows,
    );
  }
};

// Small textures are painted once during scene loading; the loop only updates uniforms.
const TRAIL_LENGTH = 13;
const TILE_LENGTH = 5;

const getCurseRunnerX = (distance, reducedMotion) => (
  (Math.sin(distance * 0.045) * 2.1 + Math.sin(distance * 0.019) * 0.65)
  * (reducedMotion ? 0.25 : 1)
);

// Reuse existing surface draws: infection changes their color, never their alpha or the notes.
const attachCurseToEnvironment = (effect, roadSurface, environmentGroup, roadDecals) => {
  const materials = new Set();
  const attach = (material, ground = false) => {
    if (!material?.map || materials.has(material)) return;
    materials.add(material);
    material.onBeforeCompile = (shader) => {
      Object.assign(shader.uniforms, effect.infectionUniforms);
      shader.vertexShader = `varying vec3 curseWorld;\nvarying vec4 curseClip;\nvarying vec2 curseUv;\n${shader.vertexShader}`;
      shader.vertexShader = shader.vertexShader.replace('#include <project_vertex>', `
        #include <project_vertex>
        vec4 cursePosition = vec4(transformed, 1.0);
        #ifdef USE_INSTANCING
          cursePosition = instanceMatrix * cursePosition;
        #endif
        curseWorld = (modelMatrix * cursePosition).xyz;
        curseClip = gl_Position;
        curseUv = uv;
      `);
      shader.fragmentShader = `
        uniform float curseProgress;
        uniform float curseDetail;
        uniform float curseScroll;
        uniform sampler2D curseMap;
        varying vec3 curseWorld;
        varying vec4 curseClip;
        varying vec2 curseUv;
        ${shader.fragmentShader}
      `;
      shader.fragmentShader = shader.fragmentShader.replace('#include <map_fragment>', `
        #include <map_fragment>
        vec2 curseScreen = curseClip.xy / max(0.001, curseClip.w);
        float curseEdge = max(abs(curseScreen.x), max(0.0, -curseScreen.y) * 0.85);
        float curseCoverage = smoothstep(1.1 - curseProgress * 1.5, 1.26 - curseProgress * 1.5, curseEdge);
        float curseFront = mix(12.0, -90.0, curseProgress);
        curseCoverage *= smoothstep(curseFront - 8.0, curseFront + 8.0, curseWorld.z);
        curseCoverage *= smoothstep(0.0, 0.12, curseProgress);
        vec3 curseColor = vec3(0.15, 0.045, 0.21);
        float curseAmount = 0.48;
        if (curseDetail > 0.5 && curseCoverage > 0.001) {
          vec2 inkUv = ${ground
    ? 'vec2(curseWorld.x / 5.0, curseWorld.z / 5.0 - curseScroll)'
    : 'curseUv * vec2(3.0, 2.0)'};
          vec4 curseInk = texture2D(curseMap, fract(inkUv));
          curseColor += curseInk.rgb * 0.55;
          curseAmount += curseInk.a * 0.27;
        }
        diffuseColor.rgb = mix(diffuseColor.rgb, diffuseColor.rgb * 0.4 + curseColor, curseCoverage * curseAmount);
      `);
    };
    material.customProgramCacheKey = () => `curse-surface-${ground ? 'ground' : 'wall'}`;
    material.needsUpdate = true;
  };
  attach(roadSurface.material, true);
  environmentGroup.traverse((node) => { if (node.isMesh) attach(node.material); });
  roadDecals.items.forEach((item) => attach(item.material, true));
};

const paintTexture = (THREE, width, height, paint) => {
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  paint(canvas.getContext('2d'), width, height);
  const texture = new THREE.CanvasTexture(canvas);
  texture.minFilter = THREE.LinearFilter;
  texture.magFilter = THREE.LinearFilter;
  texture.generateMipmaps = false;
  return texture;
};

const paintGlow = (context, x, y, radius, color) => {
  const gradient = context.createRadialGradient(x, y, 0, x, y, radius);
  gradient.addColorStop(0, color);
  gradient.addColorStop(1, 'rgba(0, 0, 0, 0)');
  context.fillStyle = gradient;
  context.fillRect(x - radius, y - radius, radius * 2, radius * 2);
};

const createStainTexture = (THREE) => paintTexture(THREE, 128, 256, (context, width, height) => {
  let seed = 7419;
  const random = () => {
    seed = (seed * 1664525 + 1013904223) >>> 0;
    return seed / 4294967296;
  };
  for (let index = 0; index < 42; index += 1) {
    const x = width * (0.25 + random() * 0.5);
    const y = random() * height;
    const radius = 16 + random() * 25;
    // Wrap the artwork itself so the scrolling texture has no seam.
    for (let wrap = -1; wrap <= 1; wrap += 1) {
      paintGlow(context, x, y + wrap * height, radius, 'rgba(24, 5, 34, 0.72)');
    }
  }
  for (let index = 0; index < 24; index += 1) {
    let x = width * (0.3 + random() * 0.4);
    let y = random() * height;
    context.beginPath();
    context.moveTo(x, y);
    for (let step = 0; step < 4; step += 1) {
      x += (random() - 0.5) * 18;
      y += 3 + random() * 5;
      context.lineTo(x, y);
    }
    context.strokeStyle = index % 3 ? 'rgba(143, 72, 190, 0.6)' : 'rgba(161, 201, 67, 0.65)';
    context.lineWidth = 1.2;
    context.stroke();
  }
});

const createRunnerCurse = (THREE, roadY, runnerZ, reducedMotion) => {
  const group = new THREE.Group();
  const geometry = new THREE.PlaneGeometry(1, 1);
  const shadowTexture = paintTexture(THREE, 64, 64, (context) => {
    paintGlow(context, 32, 32, 31, 'rgba(3, 0, 9, 0.9)');
  });
  const shadowMaterial = new THREE.MeshBasicMaterial({
    map: shadowTexture, transparent: true, depthWrite: false, opacity: 0.9,
  });
  const shadow = new THREE.Mesh(geometry, shadowMaterial);
  shadow.rotation.x = -Math.PI / 2;
  shadow.scale.set(3.6, 2.3, 1);
  shadow.position.set(0, roadY + 0.045, runnerZ);
  group.add(shadow);

  const stainTexture = createStainTexture(THREE);
  stainTexture.wrapT = THREE.RepeatWrapping;
  const trailMaterial = new THREE.ShaderMaterial({
    transparent: true,
    depthWrite: false,
    uniforms: {
      stain: { value: stainTexture },
      scroll: { value: 0 },
      reach: { value: 0 },
      travel: { value: 0 },
      wander: { value: reducedMotion ? 0.25 : 1 },
    },
    vertexShader: `
      uniform float travel;
      uniform float wander;
      varying vec2 trailUv;
      void main() {
        trailUv = uv;
        float behind = (1.0 - uv.y) * ${TRAIL_LENGTH.toFixed(1)};
        float past = max(0.0, travel - behind);
        float center = (sin(past * 0.045) * 2.1 + sin(past * 0.019) * 0.65) * wander;
        vec3 spread = position;
        spread.x = position.x * mix(3.5, 12.0, 1.0 - uv.y) + center;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(spread, 1.0);
      }
    `,
    fragmentShader: `
      uniform sampler2D stain;
      uniform float scroll;
      uniform float reach;
      varying vec2 trailUv;
      void main() {
        float behind = (1.0 - trailUv.y) * ${TRAIL_LENGTH.toFixed(1)};
        vec4 ink = texture2D(stain, vec2(trailUv.x, trailUv.y * ${(TRAIL_LENGTH / TILE_LENGTH).toFixed(2)} + scroll));
        float fade = smoothstep(0.0, 0.55, behind);
        fade *= 1.0 - smoothstep(0.35, 0.5, abs(trailUv.x - 0.5));
        fade *= 1.0 - smoothstep(${(TRAIL_LENGTH * 0.45).toFixed(2)}, ${TRAIL_LENGTH.toFixed(1)}, behind);
        fade *= 1.0 - smoothstep(max(0.0, reach - 1.0), max(0.01, reach), behind);
        gl_FragColor = vec4(ink.rgb, ink.a * fade * 0.82);
      }
    `,
  });
  const trailGeometry = new THREE.PlaneGeometry(1, 1, 1, 24);
  const trail = new THREE.Mesh(trailGeometry, trailMaterial);
  trail.frustumCulled = false; // The vertex shader widens and bends the strip beyond its base bounds.
  trail.rotation.x = -Math.PI / 2;
  trail.scale.set(1, TRAIL_LENGTH, 1);
  trail.position.set(0, roadY + 0.035, runnerZ + TRAIL_LENGTH / 2);
  group.add(trail);

  const beamTexture = paintTexture(THREE, 64, 128, (context) => {
    context.save();
    context.scale(1, 2);
    paintGlow(context, 32, 33, 29, 'rgba(120, 49, 169, 0.4)');
    paintGlow(context, 32, 43, 16, 'rgba(158, 194, 65, 0.3)');
    context.restore();
  });
  const beamMaterial = new THREE.MeshBasicMaterial({
    map: beamTexture, transparent: true, depthWrite: false,
    blending: THREE.AdditiveBlending, opacity: 0.55,
  });
  const beam = new THREE.Mesh(geometry, beamMaterial);
  beam.scale.set(2.6, 2.2, 1);
  beam.position.set(0, roadY + 1.1, runnerZ - 0.12);
  group.add(beam);

  // Unknown hardware starts conservatively. Actual frame times can lower quality further.
  const maxQuality = !reducedMotion && navigator.hardwareConcurrency >= 8
    && (navigator.deviceMemory === undefined || navigator.deviceMemory >= 4) ? 2 : 1;
  beam.visible = maxQuality === 2;
  trail.visible = false;
  return {
    group, shadow, trail, beam, reducedMotion, maxQuality, quality: maxQuality,
    travel: 0, sampleTime: 0, sampleFrames: 0, healthyTime: 0,
    runnerX: 0,
    infectionUniforms: {
      curseProgress: { value: 0 }, curseDetail: { value: 1 },
      curseScroll: { value: 0 }, curseMap: { value: stainTexture },
    },
    resources: [geometry, trailGeometry, shadowTexture, shadowMaterial, stainTexture, trailMaterial, beamTexture, beamMaterial],
  };
};

const resetRunnerCurse = (effect) => {
  effect.travel = 0;
  effect.runnerX = 0;
  effect.shadow.position.x = 0;
  effect.beam.position.x = 0;
  effect.infectionUniforms.curseProgress.value = 0;
  effect.infectionUniforms.curseScroll.value = 0;
  effect.trail.material.uniforms.travel.value = 0;
  effect.trail.material.uniforms.scroll.value = 0;
  effect.trail.material.uniforms.reach.value = 0;
  effect.trail.visible = false;
  effect.sampleTime = 0;
  effect.sampleFrames = 0;
  effect.healthyTime = 0;
};

const updateRunnerCurse = (effect, distance, frameDelta, visualTime, songTime = 0) => {
  // Ignore tab/resume gaps, and use unclamped frame times for quality decisions.
  if (frameDelta > 0 && frameDelta < 1) {
    effect.sampleTime += Math.min(frameDelta, 0.25);
    effect.sampleFrames += 1;
    if (effect.sampleTime >= 2) {
      const average = effect.sampleTime / effect.sampleFrames;
      if (average > 0.03) {
        effect.quality = Math.max(0, effect.quality - 1);
        effect.healthyTime = 0;
      } else if (average < 0.02) {
        effect.healthyTime += effect.sampleTime;
        if (effect.healthyTime >= 8) {
          effect.quality = Math.min(effect.maxQuality, effect.quality + 1);
          effect.healthyTime = 0;
        }
      } else {
        effect.healthyTime = 0;
      }
      effect.sampleTime = 0;
      effect.sampleFrames = 0;
    }
  }
  effect.travel += distance;
  effect.runnerX = getCurseRunnerX(effect.travel, effect.reducedMotion);
  effect.shadow.position.x = effect.runnerX;
  effect.beam.position.x = effect.runnerX;
  effect.infectionUniforms.curseProgress.value = Math.min(1, Math.max(0, songTime) / 180);
  effect.infectionUniforms.curseDetail.value = effect.quality > 0 ? 1 : 0;
  effect.infectionUniforms.curseScroll.value = (effect.travel / TILE_LENGTH) % 1;
  const uniforms = effect.trail.material.uniforms;
  uniforms.travel.value = effect.travel;
  uniforms.scroll.value = (uniforms.scroll.value + distance / TILE_LENGTH) % 1;
  uniforms.reach.value = Math.min(TRAIL_LENGTH + 1, effect.travel);
  effect.trail.visible = effect.quality > 0 && effect.travel > 0;
  effect.beam.visible = effect.quality > 1;
  if (!effect.reducedMotion) {
    const pulse = Math.sin(visualTime * 2.4);
    effect.shadow.material.opacity = 0.84 + pulse * 0.04;
    if (effect.beam.visible) effect.beam.material.opacity = 0.5 + pulse * 0.08;
  }
};

// Beats que dura un ciclo completo del diablito (9 frames): a 125 BPM son
// 0.96s por vuelta, marcando el ritmo de la música.
const RUNNER_BEATS_PER_CYCLE = 2;

const createRunnerCharacter = (THREE, renderer, loadedImages, roadSurfaceY) => {  const frameColumns = runnerRunSheet.columns;
  const frameRows = runnerRunSheet.rows;
  const frameSequence = Array.from({ length: runnerRunSheet.frames }, (_, index) => index);
  const runnerTexture = createLoadedTexture(THREE, loadedImages, runnerRunTextureImage);
  const smileTexture = createLoadedTexture(THREE, loadedImages, runnerSmileTextureImage);
  const victoriaTexture = createLoadedTexture(THREE, loadedImages, runnerVictoriaTextureImage);
  const saltoTexture = createLoadedTexture(THREE, loadedImages, runnerSaltoTextureImage);
  const runnerHeight = 4.0;
  const runnerWidth = runnerHeight * (runnerRunSheet.frameWidth / runnerRunSheet.frameHeight);

  configurePixelSpriteTexture(THREE, renderer, runnerTexture, frameColumns, frameRows);
  configurePixelSpriteTexture(THREE, renderer, smileTexture, frameColumns, frameRows);
  configurePixelSpriteTexture(THREE, renderer, victoriaTexture, frameColumns, frameRows);
  configurePixelSpriteTexture(THREE, renderer, saltoTexture, frameColumns, frameRows);
  setSpriteSheetFrame(runnerTexture, frameSequence[0], frameColumns, frameRows);

  const runnerGeometry = new THREE.PlaneGeometry(runnerWidth, runnerHeight);
  const runnerMaterial = new THREE.MeshBasicMaterial({
    map: runnerTexture,
    fog: false,
    transparent: true,
    alphaTest: 0.08,
    side: THREE.DoubleSide,
  });
  const runnerMesh = new THREE.Mesh(runnerGeometry, runnerMaterial);
  runnerMesh.position.set(0, roadSurfaceY + (runnerHeight * 0.5), GAME_CONFIG.runner.staticZ);

  return {
    mesh: runnerMesh,
    texture: runnerTexture,
    normalTexture: runnerTexture,
    smileTexture,
    victoriaTexture,
    saltoTexture,
    // Los tres festejos comparten grilla 3x3 y fps con la base: alternar es
    // solo cambiar de textura manteniendo el índice de frame.
    celebrationTextures: [smileTexture, victoriaTexture, saltoTexture],
    celebrationIndex: 0,
    geometry: runnerGeometry,
    material: runnerMaterial,
    frameColumns,
    frameRows,
    frameSequence,
    currentFrameIndex: 0,
    frameElapsed: 0,
    // Un ciclo completo (9 frames) dura exactamente 2 beats del tema (125 BPM):
    // el diablito flota/gira marcando el ritmo en vez de ir por libre.
    baseFrameDuration: ((60 / GAME_CONFIG.bpm) * RUNNER_BEATS_PER_CYCLE) / runnerRunSheet.frames,
    frameDuration: ((60 / GAME_CONFIG.bpm) * RUNNER_BEATS_PER_CYCLE) / runnerRunSheet.frames,
    height: runnerHeight,
  };
};

const updateRunnerExpression = (runner, smiling) => {
  const celebrations = runner.celebrationTextures?.length
    ? runner.celebrationTextures
    : [runner.smileTexture];
  const texture = smiling
    ? celebrations[runner.celebrationIndex % celebrations.length]
    : runner.normalTexture;
  if (runner.texture === texture) return;
  runner.texture = texture;
  runner.material.map = texture;
  setSpriteSheetFrame(texture, runner.frameSequence[runner.currentFrameIndex], runner.frameColumns, runner.frameRows);
};

// Avanza al siguiente festejo del diablito (sonrisa -> victoria -> salto)
// y reinicia el ciclo de frames para que el cambio se note al instante.
const cycleRunnerCelebration = (runner) => {
  if (!runner?.celebrationTextures?.length) return;
  runner.celebrationIndex = ((runner.celebrationIndex || 0) + 1) % runner.celebrationTextures.length;
  runner.currentFrameIndex = 0;
  runner.frameElapsed = 0;
  const texture = runner.celebrationTextures[runner.celebrationIndex];
  runner.texture = texture;
  runner.material.map = texture;
  setSpriteSheetFrame(texture, runner.frameSequence[0], runner.frameColumns, runner.frameRows);
};

// El tema puede correr a otra velocidad (0.5x/1.5x): se escala solo el ciclo
// de animación para seguir marcando el ritmo. No toca audio ni lógica.
const setRunnerTempo = (runner, speedMultiplier) => {
  if (!runner?.baseFrameDuration || !(speedMultiplier > 0)) return;
  runner.frameDuration = runner.baseFrameDuration / speedMultiplier;
};

const createAtmosphere = (THREE, renderer, loadedImages, locationId) => {
  const group = new THREE.Group();
  const resources = [];
  if (locationId === 'ceu') return { group, resources };

  if (locationId === 'parque') {
    return { group, resources, cloudTexture: null };
  }

  if (locationId === 'tollocan') {
    // Torres Bicentenario al fondo: plano estático inalcanzable, fuera del
    // loop de scroll. PixelLab de noche, iluminadas de colores.
    const towersTexture = createSceneryTexture(THREE, renderer, loadedImages, tollocanTowersImage);
    towersTexture.minFilter = THREE.LinearFilter;
    const towersGeometry = new THREE.PlaneGeometry(34, 34 * (486 / 512));
    const towersMaterial = new THREE.MeshBasicMaterial({
      map: towersTexture,
      transparent: true,
      alphaTest: 0.035,
      fog: true,
    });
    const towers = new THREE.Mesh(towersGeometry, towersMaterial);
    towers.position.set(9, 11.5, -66);
    group.add(towers);
    resources.push(towersTexture, towersGeometry, towersMaterial);
    return { group, resources, cloudTexture: null };
  }

  const skyTexture = createSceneryTexture(THREE, renderer, loadedImages, skyTextureImage);
  skyTexture.minFilter = THREE.LinearFilter;
  // Overscan the backdrop so the strongest camera sway/FOV never exposes
  // the edge of the PixelLab sky plane, including on wide displays.
  const skyGeometry = new THREE.PlaneGeometry(240, 120);
  const skyMaterial = new THREE.MeshBasicMaterial({ map: skyTexture, fog: false });
  const sky = new THREE.Mesh(skyGeometry, skyMaterial);
  sky.position.set(0, 20, -72);
  group.add(sky);

  const cloudTexture = configurePixelSpriteTexture(
    THREE,
    renderer,
    createLoadedTexture(THREE, loadedImages, cloudTextureImage),
  );
  cloudTexture.repeat.set(1.7, 1);
  const cloudGeometry = new THREE.PlaneGeometry(220, 54);
  const cloudMaterial = new THREE.MeshBasicMaterial({
    map: cloudTexture,
    transparent: true,
    opacity: 0.72,
    alphaTest: 0.035,
    depthWrite: false,
    fog: false,
  });
  const clouds = new THREE.Mesh(cloudGeometry, cloudMaterial);
  clouds.position.set(0, 17, -68);
  group.add(clouds);

  resources.push(skyTexture, skyGeometry, skyMaterial, cloudTexture, cloudGeometry, cloudMaterial);

  const mountainTexture = createSceneryTexture(THREE, renderer, loadedImages, mountainTextureImage);
  // PixelLab kept the reference city below the mountain. Sampling only the
  // upper 50 rows preserves the real Nevado silhouette without extra pixels.
  const mountainCropHeight = 50 / 225;
  mountainTexture.repeat.set(1, mountainCropHeight);
  mountainTexture.offset.set(0, 1 - mountainCropHeight);
  const mountainGeometry = new THREE.PlaneGeometry(88, 11);
  const mountainMaterial = new THREE.MeshBasicMaterial({
    map: mountainTexture,
    transparent: true,
    alphaTest: 0.035,
    fog: false,
  });
  const mountain = new THREE.Mesh(mountainGeometry, mountainMaterial);
  mountain.position.set(0, 4.25, -65.5);
  group.add(mountain);

  resources.push(
    mountainTexture,
    mountainGeometry,
    mountainMaterial,
  );
  return { group, resources, cloudTexture };
};

const createAmbientAnimals = (THREE, renderer, loadedImages, roadSurfaceY, locationId) => {
  const group = new THREE.Group();
  const resources = [];
  const items = [];
  if (locationId === 'ceu' || locationId === 'tollocan') return { group, resources, items };
  const random = createSeededRandom(locationId === 'parque' ? 0x5041524b : (Date.now() ^ 0x71c3a5d9) >>> 0);
  const frameSequence = [0, 1, 2, 3, 4, 5, 6, 7];
  const ambientConf = GAME_CONFIG.ambientAnimals || {};
  const lateralMin = ambientConf.lateralMin ?? 5.6;
  const lateralMax = ambientConf.lateralMax ?? 7.8;
  const speedMin = ambientConf.speedMin ?? 0.55;
  const speedMax = ambientConf.speedMax ?? 0.9;
  // En el norte los animales son perro callejero + ciclistas de ida y regreso
  // (PixelLab, low top-down, misma estética que el vendedor del triciclo);
  // en el resto, perro + gato genéricos.
  const animalTypes = locationId === 'norte'
    ? [
      {
        kind: 'dog', image: northernStreetDogImage,
        height: ambientConf.dogHeight ?? 4.2, fps: northernStreetDogSheet.fps,
        aspect: northernStreetDogSheet.frameWidth / northernStreetDogSheet.frameHeight,
        columns: northernStreetDogSheet.columns, rows: northernStreetDogSheet.rows,
        // El sprite trae ~30% de padding inferior transparente: el centro va
        // bajo para que las patas visibles pisen el suelo y no floten.
        groundFactor: 0.23,
      },
      {
        kind: 'cyclist', image: northernCyclistFrontImage,
        height: ambientConf.cyclistHeight ?? 4.2, fps: northernCyclistFrontSheet.fps,
        aspect: northernCyclistFrontSheet.frameWidth / northernCyclistFrontSheet.frameHeight,
        columns: northernCyclistFrontSheet.columns, rows: northernCyclistFrontSheet.rows,
        // De frente por las vías, hacia la cámara (ida): más rápido que el
        // scroll para que el acercamiento se note igual que el alejamiento.
        travelDir: 1,
        speedMin: ambientConf.cyclistSpeedMin ?? 1.5,
        speedMax: ambientConf.cyclistSpeedMax ?? 1.9,
        // El contenido llega a 155/170: como el triciclo del vendedor, el
        // centro va bajo para que las ruedas pisen el suelo.
        groundFactor: 155 / 170 - 0.5,
      },
      {
        kind: 'cyclist', image: northernCyclistBackImage,
        height: ambientConf.cyclistHeight ?? 4.2, fps: northernCyclistBackSheet.fps,
        aspect: northernCyclistBackSheet.frameWidth / northernCyclistBackSheet.frameHeight,
        columns: northernCyclistBackSheet.columns, rows: northernCyclistBackSheet.rows,
        // De espaldas por las vías, alejándose de la cámara (regreso).
        travelDir: -1,
        groundFactor: 157 / 170 - 0.5,
      },
    ]
    : locationId === 'parque'
      ? [
        {
          kind: 'rabbit', image: parkRabbitTextureImage,
          height: 2.25, fps: parkRabbitSheet.fps, aspect: parkRabbitSheet.frameWidth / parkRabbitSheet.frameHeight,
          columns: parkRabbitSheet.columns, rows: parkRabbitSheet.rows, groundFactor: 56 / 64 - 0.5,
        },
        {
          kind: 'squirrel', image: parkSquirrelTextureImage,
          height: 2.05, fps: parkSquirrelSheet.fps, aspect: parkSquirrelSheet.frameWidth / parkSquirrelSheet.frameHeight,
          columns: parkSquirrelSheet.columns, rows: parkSquirrelSheet.rows, groundFactor: 60 / 64 - 0.5,
        },
      ]
      : [
      {
        kind: 'dog', image: dogRunTextureImage,
        height: ambientConf.dogHeight ?? 4.2, fps: 10, aspect: 1,
        columns: 4, rows: 2,
        // El sprite trae ~30% de padding inferior transparente: el centro va
        // bajo para que las patas visibles pisen el suelo y no floten.
        groundFactor: 0.23,
      },
      {
        kind: 'cat', image: catRunTextureImage, height: ambientConf.catHeight ?? 3.53, fps: 12,
        columns: 4, rows: 2,
        groundFactor: 0.21,
      },
    ];
  const pickLateral = () => lateralMin + random() * Math.max(0.5, lateralMax - lateralMin);
  const pickMotion = (fps, minSpeed, maxSpeed) => {
    const strideFreq = (fps / frameSequence.length) * Math.PI * 2;
    return {
      // Rebote de galope sincronizado con el ciclo de zancada (8 frames).
      bobFreq: strideFreq,
      bobAmp: (ambientConf.bobAmp ?? 0.21) * (0.85 + random() * 0.3),
      // Deriva lateral lenta: deambulan sin vibracion nerviosa.
      wanderFreq: 0.45 + random() * 0.35,
      wanderAmp: (ambientConf.wanderAmpMin ?? 0.45)
        + random() * Math.max(0.1, (ambientConf.wanderAmpMax ?? 0.9) - (ambientConf.wanderAmpMin ?? 0.45)),
      speedFactor: minSpeed + random() * Math.max(0.1, maxSpeed - minSpeed),
    };
  };

  // En el norte hay 3 (perro + ciclista de ida + ciclista de regreso);
  // en el resto se respeta el conteo global.
  const animalCount = locationId === 'norte'
    ? 3
    : locationId === 'parque'
      ? (GAME_CONFIG.park?.terrestrialCount ?? 3)
      : GAME_CONFIG.ambientAnimals.count;
  for (let index = 0; index < animalCount; index += 1) {
    const definition = animalTypes[index % animalTypes.length];
    const frameColumns = definition.columns ?? 4;
    const frameRows = definition.rows ?? 2;
    const texture = configurePixelSpriteTexture(
      THREE,
      renderer,
      createLoadedTexture(THREE, loadedImages, definition.image),
      frameColumns,
      frameRows,
    );
    // Los del parque empiezan quietos en el cuadro 0; solo corren al huir.
    const isPark = locationId === 'parque';
    setSpriteSheetFrame(texture, isPark ? 0 : frameSequence[index % frameSequence.length], frameColumns, frameRows);

    const geometry = new THREE.PlaneGeometry(
      definition.height * (definition.aspect || 1),
      definition.height,
    );
    const material = new THREE.MeshBasicMaterial({
      map: texture,
      transparent: true,
      alphaTest: 0.08,
      side: THREE.DoubleSide,
    });
    const mesh = new THREE.Mesh(geometry, material);
    const side = index % 2 === 0 ? -1 : 1;
    const baseX = locationId === 'parque'
      ? 6.9 + index * 0.6
      : side * pickLateral();
    const startZ = (definition.travelDir ?? 1) > 0
      // Ida: repartidos entre el fondo y la cámara.
      ? GAME_CONFIG.spawnZ + random() * (GAME_CONFIG.ground.decals.recycleZ - GAME_CONFIG.spawnZ)
      // Regreso: repartidos entre la cámara y el fondo, ya alejándose.
      : GAME_CONFIG.ambientAnimals.recycleZ
        - random() * (GAME_CONFIG.ambientAnimals.recycleZ - GAME_CONFIG.spawnZ);
    mesh.position.set(
      baseX,
      roadSurfaceY + definition.height * definition.groundFactor,
      startZ,
    );
    mesh.scale.x = side;
    group.add(mesh);

    resources.push(texture, geometry, material);
    const defSpeedMin = definition.speedMin ?? speedMin;
    const defSpeedMax = definition.speedMax ?? speedMax;
    const motion = pickMotion(definition.fps, defSpeedMin, defSpeedMax);
    items.push({
      park: isPark,
      kind: definition.kind,
      mesh,
      texture,
      frameColumns,
      frameRows,
      frameSequence,
      currentFrameIndex: isPark ? 0 : index % frameSequence.length,
      frameElapsed: 0,
      frameDuration: 1 / definition.fps,
      // Huida del parque: quietos hasta que el diablito se acerca.
      state: isPark ? 'idle' : undefined,
      fleeSpeed: isPark ? 6.5 + random() * 3 : 0,
      speedFactor: motion.speedFactor,
      speedMin: defSpeedMin,
      speedMax: defSpeedMax,
      bobFreq: motion.bobFreq,
      bobAmp: motion.bobAmp,
      wanderFreq: motion.wanderFreq,
      wanderAmp: motion.wanderAmp,
      baseX,
      phase: random() * Math.PI * 2,
      side,
      travelDir: definition.travelDir ?? 1,
      height: definition.height,
      groundFactor: definition.groundFactor,
    });
  }

  return { group, resources, items, random };
};

const createParkWaterLife = (THREE, renderer, loadedImages, roadSurfaceY, loopLength) => {
  const group = new THREE.Group();
  const resources = [];
  const items = [];
  const random = createSeededRandom(0x4c41474f);
  const parkConfig = GAME_CONFIG.park || {};
  const waterMaxX = parkConfig.water?.maxX ?? -14.25;
  const definitions = [
    {
      kind: 'duck', image: parkDuckTextureImage, sheet: parkDuckSheet,
      count: parkConfig.aquaticCount?.ducks ?? 2,
      height: 1.5, tint: 0xf3ce88, opacity: 1, minX: waterMaxX - 4, maxX: waterMaxX - 2,
      speedMin: 0.16, speedMax: 0.29,
    },
    {
      kind: 'axolotl', image: parkAxolotlTextureImage, sheet: parkAxolotlSheet,
      count: parkConfig.aquaticCount?.axolotls ?? 4,
      height: 1.6, tint: 0xffbad2, opacity: 0.9, minX: waterMaxX - 8, maxX: waterMaxX - 1,
      speedMin: 0.07, speedMax: 0.13,
    },
  ];
  definitions.forEach((definition) => {
    const texture = configurePixelSpriteTexture(
      THREE,
      renderer,
      createLoadedTexture(THREE, loadedImages, definition.image),
      definition.sheet.columns,
      definition.sheet.rows,
    );
    const geometry = new THREE.PlaneGeometry(
      definition.height * (definition.sheet.frameWidth / definition.sheet.frameHeight),
      definition.height,
    );
    const material = new THREE.MeshBasicMaterial({
      map: texture,
      color: definition.tint,
      transparent: true,
      opacity: definition.opacity,
      alphaTest: 0.08,
      depthWrite: false,
      side: THREE.DoubleSide,
    });
    resources.push(texture, geometry, material);
    for (let index = 0; index < definition.count; index += 1) {
      const instanceTexture = texture.clone();
      instanceTexture.needsUpdate = true;
      const instanceMaterial = material.clone();
      instanceMaterial.map = instanceTexture;
      resources.push(instanceTexture, instanceMaterial);
      const mesh = new THREE.Mesh(geometry, instanceMaterial);
      const baseX = definition.maxX;
      // Arranque repartido en todo el ancho para que no salgan en fila.
      const startX = definition.minX + random() * (definition.maxX - definition.minX);
      mesh.position.set(
        startX,
        roadSurfaceY + definition.height * 0.3 + 0.08,
        -12 - index * 45 - (definition.kind === 'axolotl' ? 16 : 0),
      );
      mesh.scale.x = 1;
      group.add(mesh);
      items.push({
        kind: definition.kind,
        mesh,
        texture: instanceTexture,
        frameColumns: definition.sheet.columns,
        frameRows: definition.sheet.rows,
        frameSequence: Array.from({ length: definition.sheet.frames }, (_, frame) => frame),
        currentFrameIndex: index % definition.sheet.frames,
        frameElapsed: random() / definition.sheet.fps,
        frameDuration: 1 / definition.sheet.fps,
        baseY: roadSurfaceY + definition.height * 0.3 + 0.08,
        baseX,
        minX: definition.minX,
        maxX: definition.maxX,
        horizontalDirection: -1,
        speed: definition.speedMin + random() * (definition.speedMax - definition.speedMin),
        phase: random() * Math.PI * 2,
        loopLength,
        recycleZ: parkConfig.water?.recycleZ ?? GAME_CONFIG.ground.decals.recycleZ,
        segmentIndex: index % 2,
      });
    }
  });
  return { group, resources, items, random, loopLength };
};

const createParkAirLife = (THREE, renderer, loadedImages, roadSurfaceY, loopLength) => {
  const group = new THREE.Group();
  const resources = [];
  const items = [];
  const random = createSeededRandom(0x41564553);
  const birdCount = GAME_CONFIG.park?.aerialCount ?? 3;
  const texture = configurePixelSpriteTexture(
    THREE,
    renderer,
    createLoadedTexture(THREE, loadedImages, parkHeronTextureImage),
    parkHeronSheet.columns,
    parkHeronSheet.rows,
  );
  setSpriteSheetFrame(texture, 4, parkHeronSheet.columns, parkHeronSheet.rows);
  const height = 2.8;
  const geometry = new THREE.PlaneGeometry(
    height * (parkHeronSheet.frameWidth / parkHeronSheet.frameHeight),
    height,
  );
  const material = new THREE.MeshBasicMaterial({
    map: texture,
    transparent: true,
    opacity: 0.9,
    alphaTest: 0.08,
    depthWrite: false,
    side: THREE.DoubleSide,
  });
  resources.push(texture, geometry, material);
  for (let index = 0; index < birdCount; index += 1) {
    const mesh = new THREE.Mesh(geometry, material);
    const side = index % 2 === 0 ? -1 : 1;
    const baseX = -7.5;
    const baseY = roadSurfaceY + height * (84 / 96 - 0.5) + 0.09;
    mesh.position.set(baseX, baseY, -34 - index * 65);
    mesh.scale.x = side < 0 ? 1 : -1;
    group.add(mesh);
    items.push({
      kind: 'heron',
      mesh,
      texture,
      frameColumns: parkHeronSheet.columns,
      frameRows: parkHeronSheet.rows,
      frameSequence: Array.from({ length: parkHeronSheet.frames }, (_, frame) => frame),
      currentFrameIndex: index % parkHeronSheet.frames,
      frameElapsed: random() / parkHeronSheet.fps,
      frameDuration: 1 / parkHeronSheet.fps,
      baseY,
      baseX,
      phase: random() * Math.PI * 2,
      bobAmp: 0.16 + random() * 0.1,
      bobFreq: 0.65 + random() * 0.25,
      loopLength,
      recycleZ: GAME_CONFIG.park?.water?.recycleZ ?? GAME_CONFIG.ground.decals.recycleZ,
      speed: 0.12 + random() * 0.16,
    });
  }
  return { group, resources, items, random, loopLength };
};

const disposeResources = (resources = []) => {
  resources.forEach((resource) => resource?.dispose?.());
};

const createSquareHitGeometry = (THREE) => (
  new THREE.RingGeometry(0.5, 1, 4, 1, Math.PI / 4)
);

const createCampusCorridor = (THREE, renderer, loadedImages, roadY) => {
  const { ground, corridor, spawnZ, hitZ } = GAME_CONFIG;
  const resources = [];
  const group = new THREE.Group();
  group.name = 'CU · pasillo interior';
  const segmentLength = corridor.moduleLength;
  const count = Math.ceil(ground.length / segmentLength) + 2;
  const length = count * segmentLength;
  const firstZ = (spawnZ + hitZ - length + segmentLength) * 0.5;
  const wallX = 8.8;
  const height = 8;
  const texture = (url) => {
    const map = createLoadedTexture(THREE, loadedImages, url);
    map.encoding = THREE.sRGBEncoding;
    map.magFilter = THREE.NearestFilter;
    map.anisotropy = Math.min(4, renderer.capabilities.getMaxAnisotropy());
    resources.push(map);
    return map;
  };
  const material = (color, map = null, extra = {}) => {
    const result = new THREE.MeshLambertMaterial({ color, map, ...extra });
    resources.push(result);
    return result;
  };
  const walls = [cuWallImage, cuNoticesImage, cuCracksImage].map((url) => material(0x8eaaa3, texture(url)));
  const ceiling = material(0x293d3e, walls[0].map);
  const trim = material(0x28383c);
  const metal = material(0x354750);
  const locker = material(0x9cadb1, texture(cuLockerImage));
  const cabinetMap = locker.map.clone();
  cabinetMap.offset.set(9 / 64, 45 / 192);
  cabinetMap.repeat.set(9 / 64, 90 / 192);
  cabinetMap.needsUpdate = true;
  resources.push(cabinetMap);
  const cabinetMaterial = material(0x70858d, cabinetMap);
  const door = material(0xa4a6a0, texture(cuDoorImage));
  // Crop the surrounding plaster; the frame and cabinet are modeled in 3D.
  door.map.offset.set(7 / 128, 12 / 256);
  door.map.repeat.set(116 / 128, 228 / 256);
  const glass = material(0x182e39, null, { emissive: 0x10252d });
  const concrete = material(0x697670, walls[2].map);
  const water = material(0x1c424a, null, { emissive: 0x081b20 });
  const mop = material(0x79766b);
  const tube = new THREE.MeshBasicMaterial({ color: 0xd3edcc });
  resources.push(tube);
  const box = new THREE.BoxGeometry(1, 1, 1);
  const plane = new THREE.PlaneGeometry(1, 1);
  const bucket = new THREE.CylinderGeometry(0.55, 0.42, 0.8, 12, 1, true);
  const disk = new THREE.CircleGeometry(0.5, 12);
  const rim = new THREE.TorusGeometry(0.54, 0.045, 4, 12);
  resources.push(box, plane, bucket, disk, rim);

  // Build instance transforms only in the loader. Each geometry/material pair
  // becomes one draw per loop group, including the solid 3D locker cabinets.
  const batches = new Map();
  const transform = new THREE.Object3D();
  const add = (geometry, surface, x, y, z, sx = 1, sy = 1, sz = 1, ry = 0, rx = 0, rz = 0) => {
    const key = `${geometry.id}:${surface.id}`;
    if (!batches.has(key)) batches.set(key, { geometry, surface, matrices: [] });
    transform.position.set(x, roadY + y, z);
    transform.scale.set(sx, sy, sz);
    transform.rotation.set(rx, ry, rz);
    transform.updateMatrix();
    batches.get(key).matrices.push(transform.matrix.clone());
  };
  const block = (surface, x, y, z, sx, sy, sz) => add(box, surface, x, y, z, sx, sy, sz);
  for (let index = 0; index < count; index += 1) {
    const z = firstZ + index * segmentLength;
    block(ceiling, 0, height + 0.15, z, wallX * 2 + 0.6, 0.3, segmentLength);
    block(trim, 0, height - 0.12, z - segmentLength / 2, wallX * 2, 0.24, 0.22);
    block(trim, 0, height - 0.22, z, 3.3, 0.18, 0.65);
    if (index % 4 !== 1) block(tube, 0, height - 0.33, z, 2.9, 0.08, 0.28);
    for (const side of [-1, 1]) {
      const x = side * wallX;
      const faceRotation = -side * Math.PI / 2;
      const wallMaterial = walls[(index + (side === 1 ? 1 : 0)) % walls.length];
      const stairs = (index + (side === 1 ? 3 : 0)) % 9 === 4;
      if (stairs) {
        // A real opening and recessed staircase, outside the playable lanes.
        block(wallMaterial, x, height / 2, z - 5.5, 0.35, height, 5);
        block(wallMaterial, x, height / 2, z + 5.5, 0.35, height, 5);
        block(wallMaterial, x, 6.75, z, 0.35, 2.5, 6);
        block(ceiling, side * (wallX + 4.8), 4, z, 0.3, 8, 6);
        block(ceiling, side * (wallX + 2.4), height, z, 4.8, 0.3, 6);
        block(wallMaterial, side * (wallX + 2.4), 4, z - 3, 4.8, 8, 0.3);
        block(wallMaterial, side * (wallX + 2.4), 4, z + 3, 4.8, 8, 0.3);
        for (let step = 0; step < 8; step += 1) {
          const rise = (step + 1) * 0.36;
          block(concrete, side * (wallX + 0.3 + step * 0.55), rise / 2, z, 0.56, rise, 5.7);
          block(trim, side * (wallX + 0.3 + step * 0.55), rise + 0.65, z + 2.4, 0.07, 1.3, 0.07);
        }
        add(box, metal, side * (wallX + 2.2), 2.65, z + 2.4, 5.2, 0.1, 0.1, 0, 0, side * 0.58);
      } else {
        block(wallMaterial, x, height / 2, z, 0.35, height, segmentLength);
        block(trim, x - side * 0.22, 0.22, z, 0.15, 0.44, segmentLength);
        if ((index + (side === 1 ? 2 : 0)) % 5 === 0) {
          block(trim, x - side * 0.27, 4.8, z + 1, 0.18, 3, 4.5);
          block(glass, x - side * 0.38, 4.8, z + 1, 0.05, 2.7, 4.2);
          block(metal, x - side * 0.43, 4.8, z + 1, 0.1, 2.8, 0.12);
          block(metal, x - side * 0.43, 4.8, z + 1, 0.1, 0.12, 4.3);
          block(concrete, x - side * 0.45, 3.25, z + 1, 0.7, 0.15, 4.7);
        } else {
          block(trim, x - side * 0.25, 2.65, z + 2.5, 0.25, 5.3, 2.9);
          add(plane, door, x - side * 0.39, 2.6, z + 2.5, 2.65, 5.2, 1, faceRotation);
        }
        if (index % 3 !== (side === 1 ? 0 : 2)) {
          for (let cabinet = 0; cabinet < 3; cabinet += 1) {
            const lockerZ = z - 5.5 + cabinet * 1.35;
            block(cabinetMaterial, x - side * 0.82, 2.12, lockerZ, 1.25, 4.24, 1.31);
            add(plane, locker, x - side * 1.455, 2.12, lockerZ, 1.28, 4.2, 1, faceRotation);
          }
        }
      }
      // Wall fluorescents and sparse cleaning equipment, all clear of the lanes.
      block(trim, x - side * 0.3, 6.6, z - 4, 0.25, 0.45, 2.3);
      if (index % 3 !== 1) block(tube, x - side * 0.45, 6.6, z - 4, 0.12, 0.16, 2);
      if ((index + (side === 1 ? 2 : 0)) % 5 === 2) {
        const propX = side * (wallX - 2.05);
        add(bucket, metal, propX, 0.42, z + 5);
        add(disk, water, propX, 0.7, z + 5, 1, 1, 1, 0, -Math.PI / 2);
        add(rim, metal, propX, 0.83, z + 5, 1, 1, 1, 0, Math.PI / 2);
        add(box, mop, propX + side * 0.4, 1.65, z + 5.4, 0.065, 3.2, 0.065, 0, 0.12, side * 0.15);
        block(mop, propX + side * 0.6, 0.12, z + 5.65, 0.6, 0.15, 0.45);
        add(disk, water, propX - side * 0.5, 0.015, z + 4.4, 2.7, 1.5, 1, 0, -Math.PI / 2);
      }
    }
  }
  batches.forEach(({ geometry, surface, matrices }) => {
    const mesh = new THREE.InstancedMesh(geometry, surface, matrices.length);
    matrices.forEach((matrix, index) => mesh.setMatrixAt(index, matrix));
    mesh.instanceMatrix.needsUpdate = true;
    // r128 cannot compute a bounding sphere for the complete instance batch.
    mesh.frustumCulled = false;
    mesh.updateMatrix();
    mesh.matrixAutoUpdate = false;
    group.add(mesh);
    resources.push(mesh);
  });
  const trailing = group.clone(true);
  trailing.position.z = -length;
  trailing.traverse((node) => { if (node.isInstancedMesh) resources.push(node); });
  const container = new THREE.Group();
  container.add(group, trailing);
  return {
    environmentGroup: container,
    environmentResources: resources,
    environmentLoopGroups: [group, trailing],
    environmentLoopLength: length,
    streetDecor: { lampFlickerNodes: [] },
  };
};

const createParkCorridor = (THREE, renderer, loadedImages, roadSurfaceY) => {
  const { ground, corridor, spawnZ, hitZ } = GAME_CONFIG;
  const parkConfig = GAME_CONFIG.park || {};
  const resources = [];
  const segmentLength = corridor.moduleLength;
  const segmentCount = Math.ceil(ground.length / segmentLength) + 2;
  const loopLength = segmentCount * segmentLength;
  const centerZ = (spawnZ + hitZ) * 0.5;
  const firstSegmentZ = centerZ - loopLength * 0.5 + segmentLength * 0.5;
  const moduleGroup = new THREE.Group();
  moduleGroup.name = 'Parque Sierra Morelos · tramo';
  const random = createSeededRandom(0x53494552);

  const createParkTexture = (image, repeatX = 1, repeatY = 1) => {
    const texture = createLoadedTexture(THREE, loadedImages, image);
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.repeat.set(repeatX, repeatY);
    texture.magFilter = THREE.NearestFilter;
    texture.minFilter = THREE.LinearFilter;
    texture.generateMipmaps = false;
    texture.anisotropy = Math.min(4, renderer.capabilities.getMaxAnisotropy());
    texture.encoding = THREE.sRGBEncoding;
    resources.push(texture);
    return texture;
  };

  // El agua es una superficie horizontal continua; el movimiento sólo cambia
  // sus UV y no crea reflejos ni materiales por cuadro.
  const waterTexture = createParkTexture(parkWaterTextureImage, 5, loopLength / 16);
  const waterMinX = parkConfig.water?.minX ?? -20.6;
  const waterMaxX = parkConfig.water?.maxX ?? -14.25;
  const waterWidth = waterMaxX - waterMinX;
  const waterCenterX = (waterMinX + waterMaxX) * 0.5;
  const waterGeometry = new THREE.PlaneGeometry(waterWidth, loopLength);
  const waterMaterial = new THREE.MeshStandardMaterial({
    color: 0x326f79,
    map: waterTexture,
    transparent: false,
    roughness: 0.5,
    metalness: 0.02,
  });
  const water = new THREE.Mesh(waterGeometry, waterMaterial);
  water.rotation.x = -Math.PI / 2;
  water.position.set(waterCenterX, roadSurfaceY + 0.055, centerZ);
  water.renderOrder = 2;
  moduleGroup.add(water);
  resources.push(waterGeometry, waterMaterial);

  // Orilla irregular precalculada. El camino conserva una línea de costa
  // continua aunque el módulo se recicle delante de la cámara.
  const shorelinePoints = segmentCount * 4 + 1;
  const shorelineStep = loopLength / (shorelinePoints - 1);
  const shorePositions = [];
  const shoreUvs = [];
  const shoreIndices = [];
  for (let index = 0; index < shorelinePoints; index += 1) {
    const z = firstSegmentZ - segmentLength * 0.5 + index * shorelineStep;
    const bankX = -6.2;
    const waterX = waterMaxX - 0.6 - 0.55 * Math.sin(index / (shorelinePoints - 1) * Math.PI * 8);
    shorePositions.push(bankX, roadSurfaceY + 0.09, z, waterX, roadSurfaceY + 0.09, z);
    const v = index / (shorelinePoints - 1);
    shoreUvs.push(0, v, 1, v);
    if (index < shorelinePoints - 1) {
      const base = index * 2;
      shoreIndices.push(base, base + 1, base + 2, base + 1, base + 3, base + 2);
    }
  }
  const shoreGeometry = new THREE.BufferGeometry();
  shoreGeometry.setAttribute('position', new THREE.Float32BufferAttribute(shorePositions, 3));
  shoreGeometry.setAttribute('uv', new THREE.Float32BufferAttribute(shoreUvs, 2));
  shoreGeometry.setIndex(shoreIndices);
  shoreGeometry.computeVertexNormals();
  const shoreTexture = createParkTexture(parkGrassTextureImage, 1, loopLength / 10);
  const shoreMaterial = new THREE.MeshStandardMaterial({
    color: 0x5b6b49,
    map: shoreTexture,
    roughness: 1,
    metalness: 0,
    side: THREE.DoubleSide,
  });
  const shoreline = new THREE.Mesh(shoreGeometry, shoreMaterial);
  shoreline.renderOrder = 1;
  moduleGroup.add(shoreline);
  resources.push(shoreGeometry, shoreMaterial);

  // Continuous land underneath the path and woodland; no exposed plane edges.
  const landGeometry = new THREE.PlaneGeometry(150, loopLength);
  const landTexture = createParkTexture(parkGrassTextureImage, 18, loopLength / 8);
  const landMaterial = new THREE.MeshStandardMaterial({ color: 0x344b39, map: landTexture, roughness: 1 });
  const land = new THREE.Mesh(landGeometry, landMaterial);
  land.rotation.x = -Math.PI / 2;
  land.position.set(0, roadSurfaceY - 0.04, centerZ);
  moduleGroup.add(land);
  resources.push(landGeometry, landMaterial);

  const spriteDefinitions = [
    // sink: hundido extra bajo el suelo; roble y muerto traen raíces
    // expuestas que en piso plano se ven flotando, así que van más abajo.
    { image: parkTreeOakImage, height: 12.6, aspect: 128 / 192, name: 'oak', sink: 1.2 },
    { image: parkTreePineImage, height: 13.8, aspect: 128 / 192, name: 'pine' },
    { image: parkTreeDeadImage, height: 12.1, aspect: 128 / 192, name: 'dead', sink: 1.2 },
    // Variantes derivadas: conservan la estructura de los tres originales y
    // sólo cambian escala/inclinación para ampliar el bosque sin más texturas.
    { image: parkTreeOakImage, height: 10.2, aspect: 128 / 192, name: 'oak-small', variant: true, sink: 1 },
    { image: parkTreePineImage, height: 11.1, aspect: 128 / 192, name: 'pine-tall', variant: true },
  ];
  spriteDefinitions.forEach((definition) => {
    definition.texture = createSceneryTexture(THREE, renderer, loadedImages, definition.image);
    definition.geometry = new THREE.PlaneGeometry(definition.height * definition.aspect, definition.height);
    definition.material = new THREE.MeshBasicMaterial({
      map: definition.texture,
      transparent: true,
      alphaTest: 0.08,
      side: THREE.DoubleSide,
    });
    resources.push(definition.texture, definition.geometry, definition.material);
  });

  const understoryTexture = createSceneryTexture(THREE, renderer, loadedImages, parkUnderstoryImage);
  const understoryGeometry = new THREE.PlaneGeometry(4.2, 3.15);
  const understoryMaterial = new THREE.MeshBasicMaterial({
    map: understoryTexture, transparent: true, alphaTest: 0.08, side: THREE.DoubleSide,
  });
  const rockTexture = createSceneryTexture(THREE, renderer, loadedImages, parkRocksImage);
  const rockGeometry = new THREE.PlaneGeometry(3.6, 2.7);
  const rockMaterial = new THREE.MeshBasicMaterial({
    map: rockTexture, transparent: true, alphaTest: 0.08, side: THREE.DoubleSide,
  });
  const timberGeometry = new THREE.BoxGeometry(1, 1, 1);
  // Madera nocturna generada con PixelLab (pixen); el color blanco deja ver
  // la textura tal cual en postes, mesa y bancas del merendero.
  const timberTexture = createParkTexture(parkTimberTextureImage, 1, 1);
  const timberMaterial = new THREE.MeshStandardMaterial({ color: 0xffffff, map: timberTexture, roughness: 1 });
  const roofMaterial = new THREE.MeshStandardMaterial({ color: 0x455c55, roughness: 0.95 });
  resources.push(
    understoryTexture, understoryGeometry, understoryMaterial,
    rockTexture, rockGeometry, rockMaterial,
    timberGeometry, timberMaterial, roofMaterial,
  );

  const addSprite = (geometry, material, x, y, z, scaleX = 1, rotation = 0) => {
    const mesh = new THREE.Mesh(geometry, material);
    mesh.position.set(x, y, z);
    mesh.scale.x = scaleX;
    mesh.rotation.y = rotation;
    moduleGroup.add(mesh);
    return mesh;
  };

  const addShelter = (z) => {
    const shelter = new THREE.Group();
    shelter.position.set(10, roadSurfaceY, z);
    shelter.rotation.y = -0.18;
    const beam = (x, y, depth, w, h, d, material = timberMaterial, tilt = 0) => {
      const part = new THREE.Mesh(timberGeometry, material);
      part.position.set(x, y, depth);
      part.scale.set(w, h, d);
      part.rotation.z = tilt;
      shelter.add(part);
    };
    [-2, 2].forEach((x) => [-1.7, 1.7].forEach((zOffset) => beam(x, 1.65, zOffset, 0.34, 3.3, 0.34)));
    [-1, 1].forEach((side) => {
      beam(side * 1.2, 3.65, 0, 2.7, 0.18, 4.2, roofMaterial, -side * 0.35);
      beam(side * 1.1, 0.65, 0, 0.48, 0.16, 2.8);
      [-0.9, 0.9].forEach((zOffset) => beam(side * 1.1, 0.3, zOffset, 0.16, 0.6, 0.18));
    });
    beam(0, 1.1, 0, 1.3, 0.18, 2.8);
    [-0.9, 0.9].forEach((zOffset) => beam(0, 0.55, zOffset, 0.2, 1.1, 0.2));
    moduleGroup.add(shelter);
  };

  for (let index = 0; index < segmentCount; index += 1) {
    const z = firstSegmentZ + index * segmentLength;
    const tree = spriteDefinitions[index % spriteDefinitions.length];
    // Sin árboles a la izquierda: la orilla del lago queda despejada hasta
    // el horizonte y no hay siluetas flotando sobre el agua.
    addSprite(
      tree.geometry,
      tree.material,
      12.5 + random() * 1.15,
      roadSurfaceY + tree.height * 0.5 - 0.6 - (tree.sink ?? 0),
      z - segmentLength * 0.24,
      random() > 0.5 ? -1 : 1,
      (random() - 0.5) * 0.08,
    );
    if (index % 2 === 0) {
      addSprite(
        understoryGeometry,
        understoryMaterial,
        -7.7,
        roadSurfaceY + 1.12,
        z - segmentLength * 0.28,
        random() > 0.5 ? -1 : 1,
      );
      addSprite(
        rockGeometry,
        rockMaterial,
        -7.4,
        roadSurfaceY + 0.92,
        z + segmentLength * 0.24,
        random() > 0.5 ? -1 : 1,
      );
    }
    // Dos claros de merendero por tramo reciclable; ambos quedan a la derecha
    // y nunca ocupan los dos carriles de notas.
    if (index === 4 || index === 10) {
      addShelter(z);
    }
    // Overlapping rows fill the horizon and conceal the outer forest boundary.
    for (let row = 0; row < 3; row += 1) {
      if (row === 0 && (index === 4 || index === 10)) continue;
      for (let offset = 0; offset < 3; offset += 1) {
        const denseTree = spriteDefinitions[(index + row + offset) % spriteDefinitions.length];
        // La base queda 0.7 bajo el suelo: con el follaje a 1.4x ningún
        // tronco flota aunque el sprite traiga padding transparente abajo.
        const mesh = addSprite(denseTree.geometry, denseTree.material,
          10 + row * 7 + random() * 2, roadSurfaceY + denseTree.height * 0.7 - 0.7 - (denseTree.sink ?? 0),
          z + offset * segmentLength / 3, random() > 0.5 ? -1.4 : 1.4);
        mesh.scale.y = 1.4;
      }
    }
  }

  // Batch repeated vegetation. r128 needs explicit culling/disposal for instances.
  const vegetation = new Set([
    ...spriteDefinitions.map((definition) => definition.geometry), understoryGeometry, rockGeometry,
  ]);
  const batches = new Map();
  [...moduleGroup.children].forEach((mesh) => {
    if (!vegetation.has(mesh.geometry)) return;
    if (!batches.has(mesh.geometry)) batches.set(mesh.geometry, { material: mesh.material, matrices: [] });
    mesh.scale.x = Math.abs(mesh.scale.x);
    mesh.updateMatrix();
    batches.get(mesh.geometry).matrices.push(mesh.matrix.clone());
    moduleGroup.remove(mesh);
  });
  batches.forEach(({ material, matrices }, geometry) => {
    const mesh = new THREE.InstancedMesh(geometry, material, matrices.length);
    matrices.forEach((matrix, index) => mesh.setMatrixAt(index, matrix));
    mesh.instanceMatrix.needsUpdate = true;
    mesh.frustumCulled = false;
    moduleGroup.add(mesh);
    resources.push(mesh);
  });
  moduleGroup.traverse((node) => {
    if (node === moduleGroup) return;
    node.updateMatrix();
    node.matrixAutoUpdate = false;
  });
  const trailing = moduleGroup.clone(true);
  trailing.position.z = -loopLength;
  trailing.traverse((node) => { if (node.isInstancedMesh) resources.push(node); });
  const container = new THREE.Group();
  container.add(moduleGroup, trailing);
  return {
    environmentGroup: container,
    environmentResources: resources,
    environmentLoopGroups: [moduleGroup, trailing],
    environmentLoopLength: loopLength,
    parkWater: { texture: waterTexture },
    streetDecor: { lampFlickerNodes: [], vendorAnimation: null },
  };
};

const createTollocanCorridor = (THREE, renderer, loadedImages, roadSurfaceY) => {
  // Paseo Tollocan: carretera al centro, arboleda PixelLab a ambos lados,
  // vía del tren a la derecha y señalización de velocidad/tránsito.
  const { corridor, ground, spawnZ, hitZ } = GAME_CONFIG;
  const resources = [];
  const centerZ = (spawnZ + hitZ) * 0.5;
  const segmentLength = corridor.moduleLength;
  // 384 world units / (40 * 0.55) ≈ 17.5 seconds at normal playback speed.
  const segmentCount = Math.max(24, Math.ceil(ground.length / segmentLength) + 2);
  const loopLength = segmentCount * segmentLength;
  const firstSegmentZ = centerZ - loopLength * 0.5 + segmentLength * 0.5;
  const monumentZ = centerZ - loopLength * 0.32;
  const random = createSeededRandom(0x544f4c4c);
  const moduleGroup = new THREE.Group();
  moduleGroup.name = 'Tollocan · carretera arbolada';

  const stoneTexture = createSceneryTexture(THREE, renderer, loadedImages, tollocanVolcanicStoneImage);
  const concreteTexture = createSceneryTexture(THREE, renderer, loadedImages, tollocanConcreteImage);
  [stoneTexture, concreteTexture].forEach((texture) => {
    texture.wrapS = THREE.RepeatWrapping;
    texture.wrapT = THREE.RepeatWrapping;
    texture.repeat.set(2.5, 2.5);
    texture.minFilter = THREE.LinearMipmapLinearFilter;
    texture.generateMipmaps = true;
  });
  resources.push(stoneTexture, concreteTexture);

  // Franjas de pasto a ambos lados de la cinta asfáltica.
  const grassTexture = createSceneryTexture(THREE, renderer, loadedImages, tollocanGrassImage);
  grassTexture.wrapS = THREE.RepeatWrapping;
  grassTexture.wrapT = THREE.RepeatWrapping;
  grassTexture.repeat.set(60 / 4, loopLength / 4);
  grassTexture.minFilter = THREE.LinearMipmapLinearFilter;
  const grassMaterial = new THREE.MeshStandardMaterial({ map: grassTexture, roughness: 1, metalness: 0 });
  resources.push(grassTexture, grassMaterial);
  [-38, 38].forEach((x) => {
    const geometry = new THREE.PlaneGeometry(60, loopLength);
    const mesh = new THREE.Mesh(geometry, grassMaterial);
    mesh.rotation.x = -Math.PI / 2;
    mesh.position.set(x, roadSurfaceY - 0.02, centerZ);
    moduleGroup.add(mesh);
    resources.push(geometry);
  });

  addTollocanInfrastructure(THREE, moduleGroup, resources, {
    roadSurfaceY, centerZ, loopLength, concreteTexture,
  });

  const treeDefinitions = [
    { image: tollocanTreeImage, height: 15, aspect: 96 / 108 },
    { image: tollocanTreeAImage, height: 12, aspect: 1 },
    { image: tollocanTreeBImage, height: 13, aspect: 1 },
    { image: tollocanTreeCImage, height: 11.5, aspect: 1 },
  ];
  treeDefinitions.forEach((definition) => {
    definition.texture = createSceneryTexture(THREE, renderer, loadedImages, definition.image);
    definition.geometry = new THREE.PlaneGeometry(definition.height * definition.aspect, definition.height);
    definition.material = new THREE.MeshBasicMaterial({
      map: definition.texture, transparent: true, alphaTest: 0.08, side: THREE.DoubleSide,
    });
    resources.push(definition.texture, definition.geometry, definition.material);
  });

  const signDefinitions = {
    speed: { image: tollocanSpeed60Image, height: 3.6, aspect: 64 / 96 },
    curve: { image: tollocanCurveImage, height: 3.2, aspect: 1 },
    railCross: { image: tollocanRailCrossImage, height: 3.8, aspect: 64 / 96 },
  };
  Object.values(signDefinitions).forEach((definition) => {
    definition.texture = createSceneryTexture(THREE, renderer, loadedImages, definition.image);
    definition.geometry = new THREE.PlaneGeometry(definition.height * definition.aspect, definition.height);
    definition.material = new THREE.MeshBasicMaterial({
      map: definition.texture, transparent: true, alphaTest: 0.08, side: THREE.DoubleSide,
    });
    resources.push(definition.texture, definition.geometry, definition.material);
  });

  const addBillboard = (definition, x, z, flip = false, sink = 0.6) => {
    const mesh = new THREE.Mesh(definition.geometry, definition.material);
    // El hundido entierra la base del tronco/poste: los sprites traen
    // padding transparente abajo y si no se compensa se ven flotando.
    mesh.position.set(x, roadSurfaceY + definition.height * 0.5 - sink, z);
    mesh.rotation.y = (flip ? Math.PI : 0) + (x < 0 ? 0.08 : -0.08);
    moduleGroup.add(mesh);
    return mesh;
  };

  for (let index = 0; index < segmentCount; index += 1) {
    const z = firstSegmentZ + index * segmentLength;
    const leftTree = treeDefinitions[index % treeDefinitions.length];
    const sculptureClearing = Math.abs(z - monumentZ) < 24;
    if (!sculptureClearing) {
      addBillboard(leftTree, -13.2 - random() * 2, z + (random() - 0.5) * 6, random() > 0.5);
    }
    const rightTree = treeDefinitions[(index + 1) % treeDefinitions.length];
    addBillboard(rightTree, 19.6 + random() * 0.8, z + (random() - 0.5) * 6, random() > 0.5);
    if (!sculptureClearing && index % 3 === 1) {
      const extra = treeDefinitions[(index + 2) % treeDefinitions.length];
      addBillboard(extra, -16 - random() * 3, z - segmentLength * 0.3, random() > 0.5);
    }
    // Señalización: velocidad y curva a la izquierda sobre el pasto,
    // cruce de tren al borde de la cinta, antes de la grava.
    if (!sculptureClearing && index % 6 === 2) addBillboard(signDefinitions.speed, -12.9, z, false, 0.35);
    if (!sculptureClearing && index % 6 === 5) addBillboard(signDefinitions.curve, -12.9, z, true, 0.35);
    if (index % 6 === 4) addBillboard(signDefinitions.railCross, 9.8, z + segmentLength * 0.3, false, 0.35);
  }

  moduleGroup.traverse((node) => {
    if (node === moduleGroup) return;
    node.updateMatrix();
    node.matrixAutoUpdate = false;
  });
  const trailing = moduleGroup.clone(true);
  trailing.position.z = -loopLength;
  trailing.traverse((node) => { if (node.isInstancedMesh) resources.push(node); });
  addTollocanMonument(THREE, moduleGroup, resources, roadSurfaceY, monumentZ, 0, { stoneTexture });
  addTollocanMonument(THREE, trailing, resources, roadSurfaceY, monumentZ, 1, { stoneTexture });
  const container = new THREE.Group();
  container.add(moduleGroup, trailing);
  return {
    environmentGroup: container,
    environmentResources: resources,
    environmentLoopGroups: [moduleGroup, trailing],
    environmentLoopLength: loopLength,
    streetDecor: { lampFlickerNodes: [], vendorAnimation: null },
  };
};

const createHistoricCorridor = (THREE, renderer, loadedImages, roadSurfaceY, locationId) => {
  if (locationId === 'ceu') return createCampusCorridor(THREE, renderer, loadedImages, roadSurfaceY);
  if (locationId === 'parque') return createParkCorridor(THREE, renderer, loadedImages, roadSurfaceY);
  if (locationId === 'tollocan') return createTollocanCorridor(THREE, renderer, loadedImages, roadSurfaceY);
  const { corridor, ground, spawnZ, hitZ } = GAME_CONFIG;
  const northern = locationId === 'norte';
  const hasLamps = !northern;
  const hasCables = !northern;
  const environmentGroup = new THREE.Group();
  const resources = [];
  const centerZ = (spawnZ + hitZ) * 0.5;
  const segmentLength = corridor.moduleLength;
  const segmentCount = Math.ceil(ground.length / segmentLength) + 2;
  const corridorLength = segmentCount * segmentLength;
  const firstSegmentZ = centerZ - corridorLength * 0.5 + segmentLength * 0.5;
  const historicFacades = [
    { image: portalesFacadeImage, height: 9.4 },
    { image: neoclassicalFacadeImage, height: 11.5 },
    {
      image: artNouveauFacadeImage,
      height: 11.8,
      crop: { x: 37 / 256, y: 1 - (120 / 128), width: 184 / 256, height: 103 / 128 },
    },
  ];
  const northernFacades = [
    { image: northernHouseImage, height: 8.4 },
    { image: northernChurchImage, height: 8.2 },
    { image: northernSiloImage, height: 12.4 },
  ];
  const facadeDefinitions = (northern ? northernFacades : historicFacades).map((definition) => {
    const texture = createSceneryTexture(THREE, renderer, loadedImages, definition.image);
    if (definition.crop) {
      texture.offset.set(definition.crop.x, definition.crop.y);
      texture.repeat.set(definition.crop.width, definition.crop.height);
    }
    const geometry = new THREE.PlaneGeometry(segmentLength + 0.08, definition.height);
    const material = new THREE.MeshBasicMaterial({
      map: texture,
      transparent: true,
      alphaTest: 0.045,
      side: THREE.DoubleSide,
    });
    resources.push(texture, geometry, material);
    return { ...definition, geometry, material };
  });

  const vendorFrameColumns = 4;
  const vendorFrameRows = 2;
  const vendorTexture = configurePixelSpriteTexture(
    THREE,
    renderer,
    createLoadedTexture(THREE, loadedImages, vendorPedalingTextureImage),
    vendorFrameColumns,
    vendorFrameRows,
  );
  setSpriteSheetFrame(vendorTexture, 0, vendorFrameColumns, vendorFrameRows);

  const propDefinitions = {
    ...(hasLamps && { lamp: { image: streetLampImage, height: 8, groundFactor: 0.5 } }),
    bin: { image: trashBinImage, height: 2.4, groundFactor: 245 / 256 - 0.5 },
    vendor: { texture: vendorTexture, height: 4.6, groundFactor: 243 / 256 - 0.5 },
    tree: { image: northern ? northernPalmImage : urbanTreeImage, height: northern ? 12 : 9.2, groundFactor: 0.5 },
    ...(hasCables && { utility: { image: utilityPoleImage, height: 9, groundFactor: 250 / 256 - 0.5 } }),
  };

  Object.values(propDefinitions).forEach((definition) => {
    const texture = definition.texture || createSceneryTexture(THREE, renderer, loadedImages, definition.image);
    const geometry = new THREE.PlaneGeometry(definition.height, definition.height);
    const material = new THREE.MeshBasicMaterial({
      map: texture,
      transparent: true,
      alphaTest: 0.08,
      side: THREE.DoubleSide,
    });
    Object.assign(definition, { texture, geometry, material });
    resources.push(texture, geometry, material);
  });

  const lampGlowGeometry = hasLamps ? new THREE.CircleGeometry(0.28, 12) : null;
  const cableMaterial = hasCables ? new THREE.LineBasicMaterial({
    color: 0x171412,
    transparent: true,
    opacity: 0.92,
  }) : null;
  const cablePoints = [];
  const wireAnchors = { left: [], right: [] };
  if (lampGlowGeometry) resources.push(lampGlowGeometry);
  if (cableMaterial) resources.push(cableMaterial);

  const addStreetProp = (kind, side, z, phase = 0, addLocalLight = false) => {
    const definition = propDefinitions[kind];
    const sideSign = side === 'left' ? -1 : 1;
    const roadsideOffset = {
      vendor: 1.45,
      tree: northern ? 3.1 : 2.25,
      utility: 1.25,
    }[kind] ?? 1.05;
    const mesh = new THREE.Mesh(definition.geometry, definition.material);
    mesh.position.set(
      sideSign * (ground.roadWidth * 0.5 + roadsideOffset),
      roadSurfaceY + definition.height * definition.groundFactor,
      z,
    );
    // La referencia de la farola y el triciclo mira a la derecha. Voltearlos
    // en el costado derecho mantiene ambos orientados hacia el corredor.
    mesh.scale.x = side === 'right' ? -1 : 1;
    mesh.rotation.y = sideSign * 0.08;
    environmentGroup.add(mesh);

    if (kind === 'lamp' || kind === 'utility') {
      wireAnchors[side].push({
        x: mesh.position.x,
        y: roadSurfaceY + (kind === 'lamp' ? 7 : 8.25),
        z,
      });
    }

    if (kind !== 'lamp') return;

    const glowMaterial = new THREE.MeshBasicMaterial({
      color: 0xffc866,
      transparent: true,
      opacity: 0.7,
      depthWrite: false,
      blending: THREE.AdditiveBlending,
    });
    const glow = new THREE.Mesh(lampGlowGeometry, glowMaterial);
    glow.position.set(1.05, 1.36, 0.05);
    glow.userData.lampFlickerPhase = phase;
    glow.userData.lampGlow = true;
    mesh.add(glow);

    if (addLocalLight) {
      const light = new THREE.PointLight(0xffb347, 0.75, 8, 2);
      light.position.set(1.05, 1.36, 0.35);
      light.userData.lampFlickerPhase = phase;
      mesh.add(light);
    }
    resources.push(glowMaterial);
  };

  const addCableSpan = (start, end, heightOffset) => {
    const sag = Math.min(2.35, 0.55 + Math.abs(end.z - start.z) * 0.055);
    const curve = new THREE.QuadraticBezierCurve3(
      new THREE.Vector3(start.x, start.y + heightOffset, start.z),
      new THREE.Vector3(
        (start.x + end.x) * 0.5,
        ((start.y + end.y) * 0.5) + heightOffset - sag,
        (start.z + end.z) * 0.5,
      ),
      new THREE.Vector3(end.x, end.y + heightOffset, end.z),
    );
    const points = curve.getPoints(12);
    for (let index = 1; index < points.length; index += 1) {
      cablePoints.push(points[index - 1], points[index]);
    }
  };

  const connectWireAnchors = (anchors) => {
    anchors.sort((a, b) => a.z - b.z);
    if (anchors.length < 2) return;
    for (let index = 0; index < anchors.length; index += 1) {
      const start = anchors[index];
      const next = anchors[(index + 1) % anchors.length];
      const end = index === anchors.length - 1
        ? { ...next, z: next.z + corridorLength }
        : next;
      addCableSpan(start, end, 0);
      addCableSpan(start, end, -0.2);
    }
  };

  const addFacade = (definition, side, z) => {
    const mesh = new THREE.Mesh(definition.geometry, definition.material);
    mesh.position.set(
      side === 'left' ? corridor.leftWallX : corridor.rightWallX,
      roadSurfaceY - corridor.groundOverlap + definition.height * 0.5,
      z,
    );
    mesh.rotation.y = side === 'left' ? Math.PI * 0.5 : -Math.PI * 0.5;
    environmentGroup.add(mesh);
  };

  let bridgeDefinition = null;
  if (northern) {
    const texture = createSceneryTexture(THREE, renderer, loadedImages, northernBridgeImage);
    const geometry = new THREE.PlaneGeometry(29, 14.5);
    const material = new THREE.MeshBasicMaterial({
      map: texture, transparent: true, alphaTest: 0.08, side: THREE.DoubleSide,
    });
    bridgeDefinition = { geometry, material };
    resources.push(texture, geometry, material);
  }

  // Las posiciones forman una retícula fija y continua. La semilla sólo
  // decide el tipo visual del soporte, por lo que el cableado nunca cambia.
  const poleTypeRandom = createSeededRandom(0x504f4c45);
  for (let index = 0; index < segmentCount; index += 1) {
    const z = firstSegmentZ + index * segmentLength;
    if (northern) {
      addFacade(facadeDefinitions[index === 5 ? 1 : 0], 'left', z);
      addFacade(facadeDefinitions[index === 11 ? 1 : index === 9 ? 2 : 0], 'right', z);
      // Palmeral norte en conjunto, 4 veces menos frecuente: un grupo cada 36 segmentos en vez de cada 9.
      const palmCluster = index % 36 < 3;
      if (palmCluster) {
        addStreetProp('tree', index % 2 === 0 ? 'left' : 'right', z + segmentLength * 0.28);
        if (index % 3 === 1) {
          addStreetProp('tree', 'right', z - segmentLength * 0.25);
        }
      }
      if (index === 4 || index === 11) {
        const bridge = new THREE.Mesh(bridgeDefinition.geometry, bridgeDefinition.material);
        bridge.position.set(0, roadSurfaceY + 7.5, z - segmentLength * 0.25);
        environmentGroup.add(bridge);
      }
      if (index === 6 || index === 12) {
        addStreetProp('vendor', index === 6 ? 'left' : 'right', z + segmentLength * 0.12);
      }
      continue;
    }
    addFacade(facadeDefinitions[index % facadeDefinitions.length], 'left', z);
    addFacade(facadeDefinitions[(index + 1) % facadeDefinitions.length], 'right', z);

    const poleKind = poleTypeRandom() < 0.42 ? 'utility' : 'lamp';
    addStreetProp(
      poleKind,
      index % 2 === 0 ? 'left' : 'right',
      z + segmentLength * 0.28,
      index * 0.73,
      poleKind === 'lamp' && (index === 2 || index === 8),
    );
    if (index === 4 || index === 10) {
      addStreetProp('bin', index === 4 ? 'right' : 'left', z - segmentLength * 0.18);
    }
    if (index === 6 || index === 12) {
      addStreetProp('vendor', index === 6 ? 'left' : 'right', z + segmentLength * 0.12);
    }
    if (index === 3 || index === 6 || index === 9) {
      addStreetProp('tree', index === 6 ? 'right' : 'left', z - segmentLength * 0.3);
    }
  }

  if (hasCables) {
    connectWireAnchors(wireAnchors.left);
    connectWireAnchors(wireAnchors.right);
    const cableGeometry = new THREE.BufferGeometry().setFromPoints(cablePoints);
    environmentGroup.add(new THREE.LineSegments(cableGeometry, cableMaterial));
    resources.push(cableGeometry);
  }

  // These objects keep constant local transforms. Their parent loop groups
  // still move, but Three.js no longer recomputes every child matrix per frame.
  environmentGroup.traverse((node) => {
    if (node === environmentGroup) return;
    node.updateMatrix();
    node.matrixAutoUpdate = false;
  });

  const environmentLoopLength = corridorLength;
  const trailingEnvironmentGroup = environmentGroup.clone(true);
  trailingEnvironmentGroup.position.z = -environmentLoopLength;

  const environmentContainer = new THREE.Group();
  environmentContainer.add(environmentGroup);
  environmentContainer.add(trailingEnvironmentGroup);

  const lampFlickerNodes = [];
  environmentContainer.traverse((node) => {
    if (Number.isFinite(node.userData?.lampFlickerPhase)) lampFlickerNodes.push(node);
  });

  return {
    environmentGroup: environmentContainer,
    environmentResources: resources,
    environmentLoopGroups: [environmentGroup, trailingEnvironmentGroup],
    environmentLoopLength,
    streetDecor: {
      lampFlickerNodes,
      vendorAnimation: {
        texture: vendorTexture,
        frameColumns: vendorFrameColumns,
        frameRows: vendorFrameRows,
        frameSequence: [0, 1, 2, 3, 4, 5, 6, 7],
        currentFrameIndex: 0,
        frameElapsed: 0,
        frameDuration: 0.1,
      },
    },
  };
};

export {
  GAME_IMAGE_ASSETS,
  getGameImageAssets,
  createRoadSurface,
  createRoadDecals,
  setSpriteSheetFrame,
  advanceSpriteAnimation,
  createRunnerCharacter,
  updateRunnerExpression,
  cycleRunnerCelebration,
  setRunnerTempo,
  createRunnerCurse,
  attachCurseToEnvironment,
  updateRunnerCurse,
  resetRunnerCurse,
  createAtmosphere,
  createAmbientAnimals,
  createParkWaterLife,
  createParkAirLife,
  disposeResources,
  createSquareHitGeometry,
  createHistoricCorridor,
};
